import ExchangeRateBadge from "@/components/home/ExchangeRateBadge";

export const AnnouncementBar = () => {
  const go = () => document.getElementById("precios")?.scrollIntoView({ behavior: "smooth", block: "start" });
  return (
    <div className="announce" data-testid="announcement-bar">
      <div className="mt-container flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 py-2.5 text-center">
        <p className="font-medium leading-snug">
          0% de comisión en todos los planes · Plan Free gratis para siempre · <span className="whitespace-nowrap">Alta express en minutos</span>
        </p>
        <span className="hidden lg:inline text-white/60">|</span>
        <span className="hidden lg:inline-flex text-white/95"><ExchangeRateBadge compact /></span>
        <button
          onClick={go}
          className="shrink-0 bg-white/15 hover:bg-white/25 border border-white/40 rounded-full px-4 py-1 text-sm font-semibold transition-colors"
          data-track="announcement-ver-kit"
          data-testid="announcement-cta"
        >
          Ver planes en MXN →
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBar;
